var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreenCheck = function SvgGreenCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_658",
    "data-name": "Grupo 658",
    transform: "translate(-153 -433)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(153 433)",
    fill: "#4ac326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2355",
    "data-name": "Caminho 2355",
    d: "M28.182,21.35,15.87,35.577,8.483,29.284,5.2,33.115l11.217,9.849L32.012,24.633Z",
    transform: "translate(159.317 426.104)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green-check.ff7cd94c.svg";
export { ForwardRef as ReactComponent };